<template>
  <v-container class="mb-3">
    <!-- Module deletion modal -->
    <delete-modal :yesFunc="deleteItem" ref="deleteModalRef" />
    <!-- Notification create start -->
    <div v-if="isCreate">
      <!-- Sticky publish button start -->
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        dark
        fixed
        bottom
        right
        big
        class="ma-2 mr-4"
        elevation="0"
        style="z-index: 9999"
        color="primary"
        @click="stickyPublishOperation"
      >
        {{ $t("buttons.save") }}
      </v-btn>
      <!-- Sticky publish button end -->
      <!-- Page Header End -->
      <!-- Notification -->
      <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
        <form @submit.prevent="handleSubmit(sendForm)">
          <!-- Form buttons start -->
          <!-- Page Header -->

          <v-card-title style="color: #595959">
            <v-row>
              <v-col class="py-2 pl-0">{{ $t("title.notifications") }}</v-col>
              <v-spacer />
              <v-btn
                small
                type="submit"
                class="ma-2 mr-4"
                elevation="0"
                outlined
                color="info"
              >
                {{ $t("buttons.save") }}
              </v-btn>
              <v-btn
                small
                class="ma-2 mr-4"
                elevation="0"
                outlined
                color="info"
                @click="
                  isCreate = false;
                  clearModal();
                  getTableList();
                "
              >
                {{ $t("buttons.cancel") }}
              </v-btn>
            </v-row>
          </v-card-title>
          <!-- Form buttons end -->

          <v-divider />

          <v-card-text class="px-0 py-10">
            <!-- Title start -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <StatusSelect
                  v-model="notificationModel.Status"
                  :items="statusItems"
                  label="Durum"
                  clearable
                  rules="required"
                  :inactiveValues="[null, 20, 30]"
                  style="min-width: 180px"
                  item-text="label"
                  item-value="value"
                />
              </v-banner>
            </v-card-text>
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title">{{
                  $t("labels.notificationTitleDescription")
                }}</v-card-title>
                <ValidationProvider
                  name="Başlık"
                  rules="required|max:150"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    :label="$t('labels.header')"
                    clearable
                    class="mx-5"
                    v-model="notificationModel.Title"
                    :error-messages="errors[0]"
                  ></v-text-field>
                </ValidationProvider>

                <ValidationProvider
                  name="Mesaj"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="notificationModel.Description"
                    name="Case Details"
                    rows="2"
                    auto-grow
                    row-height="35"
                    clearable
                    class="mx-5"
                    clear-icon="mdi-close-circle"
                    append-outer-icon="mdi-emoticon-happy"
                    @click:append-outer="openEmojiPicker()"
                    :label="$t('labels.notificationMessage')"
                    :error-messages="errors[0]"
                  ></v-textarea>
                  <!-- <div class="error--text">{{ errors[0] }}</div> -->
                </ValidationProvider>

                <!-- Emoji Picker Start-->
                <v-dialog
                  v-model="openEmojiPickerDialog"
                  max-width="325"
                  style="border-radius: 0px"
                  hide-overlay
                  shaped
                  persistent
                >
                  <v-container fluid ma-0 pa-0 fill-height>
                    <VEmojiPicker @select="selectEmoji" />
                  </v-container>

                  <v-spacer></v-spacer>
                  <v-card
                    style="border-radius: 0px"
                    align="center"
                    justify="center"
                  >
                    <v-btn
                      color="primary"
                      text
                      @click="openEmojiPickerDialog = false"
                      style="border-radius: 0px"
                    >
                      {{ $t("buttons.ok") }}
                    </v-btn>
                  </v-card>
                </v-dialog>
                <!-- Emoji Picker end-->
              </v-banner>
            </v-card-text>
            <!-- Title end -->

            <!-- Description start -->
            <v-card-text class="px-0 py-0 add-content-card-body"> </v-card-text>
            <!-- Description end -->

            <!-- TARGET -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title">
                  {{ $t("titles.target") }}
                </v-card-title>

                <v-row class="ma-2 mr-4" justify="start" align="center">
                  <v-col cols="4">
                    <ValidationProvider
                      :name="$t('titles.target')"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-select
                        v-model="selectedTarget"
                        :items="targets"
                        :label="$t('titles.target')"
                        item-text="text"
                        item-value="value"
                        :error-messages="errors[0]"
                      ></v-select>
                      
                    </ValidationProvider>
                    </v-col>
                    <v-col>
                      <CompanySelect v-if="selectedTarget === 'Group'" multiple v-model="selectedGroupIds" />
                      <UserCategorySelect v-else-if="selectedTarget === 'AssignmentCategory'" multiple v-model="selectedUserCategories" />  
             
                      <v-autocomplete
                        v-else-if="selectedTarget === 'Users'"
                        v-model="comboSelect"
                        :items="userList"
                        :label="$t('labels.notificationUserSelect')"
                        item-value="Id"
                        :item-text="item => 
                          item.Name && item.Surname 
                            ? `${item.Name} ${item.Surname}(${item.Username})` 
                            : item.Username
                        "
                        multiple
                        small-chips
                        hide-selected
                        clearable
                        deletable-chips
                        :loading="isLoading"
                        :search-input.sync="search"
                        v-on:keyup.enter="searchCallNewTest(search)"
                      >
                        <template v-slot:append-outer>
                          <v-btn small outlined color="info" @click="searchCallNewTest(search)">
                            Ara 
                          </v-btn>
                        </template>

                        <template v-slot:no-data>
                          <p class="ml-3 mt-3">
                            {{ searchResult }}
                          </p>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
              </v-banner>
            </v-card-text>

            <!-- Notification route start -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title">
                  {{ $t("title.notificationRedirectPage") }}
                </v-card-title>

                <v-row class="ma-2 mr-4" justify="start" align="center">
                  <v-col cols="4">
                    <ValidationProvider
                      name="Yönlendirilecek Sayfa"
                      rules="required"
                      v-slot="{ errors }"
                      ref="moduleSelection"
                    >
                      <v-select
                        v-model="selectedModuleModal"
                        :items="$redirectPages"
                        :label="$t('labels.selectPage')"
                        item-text="Value"
                        return-object
                        item-value="Key"
                        :error-messages="errors[0]"
                        @change="fillInnerSelectPage(selectedModuleModal)"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    cols="4"
                    v-if="
                      selectedModuleModal.IsLink &&
                        selectedModuleModal.LinkStatus
                    "
                  >
                    <ValidationProvider
                      name="Bağlantı"
                      rules="required"
                      v-slot="{ errors }"
                      ref="moduleSelection"
                    >
                      <v-text-field
                        v-model="linkText"
                        clearable
                        :value="linkText"
                        :label="$t('labels.notificationLink')"
                        :error-messages="errors[0]"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    cols="4"
                    v-if="
                      selectedModuleModal.IsLink &&
                        !selectedModuleModal.LinkStatus
                    "
                  >
                    <ValidationProvider
                      name="Bağlantı"
                      rules="required"
                      v-slot="{ errors }"
                      ref="moduleSelection"
                    >
                      <v-text-field
                        v-model="linkText"
                        :value="linkText"
                        clearable
                        :label="$t('labels.notificationExternalLink')"
                        :error-messages="errors[0]"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    cols="4"
                    v-if="selectedModuleModal.IsDetail && flag && isDetailFlag"
                  >
                    <ValidationProvider
                      name="Yönlendirilecek sayfa"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-autocomplete
                        v-model="selectedInnerModuleModal"
                        :loading="autoLoading"
                        :items="allInnerModules"
                        :label="$t('labels.selectInnerPage')"
                        item-text="Value"
                        item-value="Key"
                        :search-input.sync="search2"
                        prepend-icon="mdi-database-search"
                        :error-messages="errors[0]"
                        class="mt-3"
                        cache-items
                        clearable
                        dense
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    cols="2"
                    v-if="selectedModuleModal.IsDetail && flag && !isDetailFlag"
                  >
                    <v-btn
                      small
                      class="ma-1"
                      outlined
                      color="info"
                      @click="activateDetails()"
                    >
                      Detay Sayfası Seç
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="2"
                    v-if="selectedModuleModal.IsDetail && flag && isDetailFlag"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          @click="closeDetails(selectedModuleModal)"
                          >mdi-close</v-icon
                        >
                      </template>
                      <span>Detayı Kapat</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-banner>
            </v-card-text>
            <!-- Notification route end -->

            <!-- Users & Groups start  -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title
                  class="add-content-title"
                >
                  {{ $t("titles.notificationSettings") }}
                </v-card-title>

                <div class="d-flex flex-sm-column flex-md-row mt-2">
                  <div>
                    <v-checkbox
                      class="font-weight-medium"
                      style="color: black !important"
                      v-model="notificationSettings.IsVisible"
                      :label="$t('labels.notificationSettings.isVisible')"
                    ></v-checkbox>
                  </div>
                  <div>
                    <v-checkbox
                      class="ml-md-6 font-weight-medium"
                      style="color: black !important"
                      v-model="notificationSettings.SendPush"
                      :label="$t('labels.notificationSettings.sendPush')"
                    ></v-checkbox>
                  </div>
                </div>
              </v-banner>
            </v-card-text>
            <!-- Users & Groups end -->

            <!-- Date and time picker start -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title">
                  {{ $t("labels.notificationDateTime") }}
                </v-card-title>

                <v-row align="center" justify="space-between" class="pr-5">
                  <v-col cols="5">
                    <v-text-field
                      v-model="dateValueDisplay"
                      :label="$t('labels.selectDate')"
                      readonly
                    >
                      <template v-slot:prepend>
                        <date-picker v-model="dateValue" />
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <time-picker v-model="timeValue" />
                  </v-col>
                </v-row>
              </v-banner>
            </v-card-text>
            <!-- Date and time picker end -->
          </v-card-text>
        </form>
      </ValidationObserver>
    </div>
    <!-- Notification create end -->
    <!-- Notification main page start -->
    <div v-if="!isCreate">
      <!-- Page content -->
      <v-card style="border-radius: 10px">
        <v-card-title style="color: #595959">
          <v-row>
            <v-col class="py-2">{{ $t("title.notifications") }}</v-col>
            <v-spacer />
            <v-btn
              small
              class="ma-2 mr-4"
              elevation="0"
              outlined
              color="info"
              @click="
                isCreate = true;
                $store.state.loadingStatus = false;
              "
            >
              {{ $t("buttons.addNew") }}
            </v-btn>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="pt-4">
          <v-row justify="end">
            <v-col cols="2">
              <v-select
                v-model="itemsPerPage"
                :items="perPageValues"
                :label="$t('labels.selectItemsPerPage')"
                item-value="value"
                item-text="name"
                @change="changeItemsPerPage()"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loadings.table"
            :options.sync="options"
            :hide-default-footer="true"
            :footer-props="{
              disablePagination: true,
              disableItemsPerPage: true,
            }"
            :no-data-text="$t('description.noList')"
          >
            <!-- eslint-disable -->
            <template v-slot:item.Status="{ item }">
              <v-chip v-if="isScheduled(item.SendedAt) && item.Status === 10" :color="statusMap['Scheduled'].color">
                <span :style="{ color: statusMap['Scheduled'].textColor }">
                  <v-icon class="mr-1" dark>
                    mdi-clock
                  </v-icon> {{ statusMap['Scheduled'].text }}
                </span>
              </v-chip>
              <div v-else style="font-weight: bold !important;">
                <v-chip :color="statusMap[item.Status || 'None'].color">
                  <span :style="{ color: statusMap[item.Status || 'None'].textColor }">
                    {{ statusMap[item.Status || 'None'].text }}
                  </span>
                </v-chip>
              </div>
            </template>
            <!-- item.TargetType == "Topic" ? "Tümü" : -->
            <template v-slot:item.TargetType="{ item }">
              {{
                item.TargetType == "User"
                  ? "Kullanıcı"
                  : item.TargetType == "Topic"
                  ? "Grup"
                  : "Tümü"
              }}
            </template>
            <template v-slot:item.Title="{ item }">
              <div style="font-weight: bold !important">{{ item.Title }}</div>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">

                  <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>{{ $t("buttons.update") }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">

                  <v-icon
                    small
                    class="mr-2"
                    @click="openDeleteModal(item)"
                    v-bind="attrs"
                    v-on="on"
                    color="error"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <span>{{ $t("buttons.delete") }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2 md4 lg4">
            <v-pagination
              @input="paginationChangeHandler"
              :value="pagination.page"
              :length="pages"
              :total-visible="10"
              circle
            ></v-pagination>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <!-- Notification main page end -->
  </v-container>
</template>

<script>
import GroupService from "../services/GroupService";
import FileService from "../services/FileService";
import ContentService from "../services/ContentService";
import AccountService from "../services/AccountService";
import NotificationService from "../services/NotificationService";
import UserService from "../services/UserService";
import DeleteModal from "../components/General/DeleteModal";
import { mapActions } from "vuex";
import { VEmojiPicker } from "v-emoji-picker";
import _ from "lodash";
import CompanySelect from "../components/CompanySelect.vue";
import UserCategorySelect from "../components/UserCategorySelect.vue";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import StatusSelect from "../components/StatusSelect.vue";
dayjs.extend(customParseFormat)

export default {
  data: () => ({
    model: ["Vuetify"],

    statusItems: [
      {
        label: "Taslak",
        value: 0
      },
      {
        label: "Aktif",
        value: 10
      },
      {
        label: "Pasif",
        value: 20
      },
      {
        label: "Silindi",
        value: 30
      },
      {
        label: "Yayınlandı",
        value: 40
      },
    ],

    statusMap: {
      None: { text: "-", color: "#727272", textColor: "#ffffff" },
      0: { text: "Draft", color: "#f5f5f5", textColor: "#666" },
      10: { text: "Active", color: "green", textColor: "white" },
      20: { text: "Passive", color: "#bdbdbd", textColor: "#444" },
      30: { text: "Deleted", color: "#FF7066", textColor: "white" },
      40: { text: "Published", color: "#03aecc", textColor: "white" }
    },

    //Notification model
    notificationModel: {
      Status: 0
    },
    items: [
      {
        Name: "Anasayfa",
        Code: "anasayfa",
      },
      {
        Name: "Bildirimler",
        Code: "bildirimler",
      },
      {
        Name: "Link",
        Code: "link",
      },
      {
        Name: "Anket",
        Code: "anket",
      },
    ],
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],
    headers: [],
    title: "",
    editorData: "",
    fileIds: [],
    tempFiles: [],
    selectedModuleModal: { Key: null },
    selectedInnerModuleModal: "",
    loadings: {
      table: false,
      send: false,
    },
    pageList: [],
    allInnerModules: [],
    groupModel: {
      Groups: [],
    },
    //End Publish model

    //For groups area
    selecItems: [],
    groupData: [],
    groupLengthAlert: false,
    groupArr: [[]],
    groupsSelectArray: [],
    corpGroup: [],
    locGroup: [],
    empGroup: [],
    allSelect: [],
    groupTypes: [],
    groupIds: [],

    //mandatory photo upload models
    selectedPhotoModel: null,
    photoLength: 0,
    selectedPhoto: [],
    selectedPhotoUrl: [],

    selectedGroupIds: [],
    selectedUserCategories: [],
    selectedTarget: "Admins",
    notificationSettings: {
      IsTest: false,
      SendPush: false,
      IsVisible: false
    },

    targets: [
      { text: 'Hepsi', value: 'All' },
      { text: 'Yöneticiler', value: 'Admins' },
      { text: 'Atama Kategorisi', value: 'AssignmentCategory' },
      { text: 'Grup', value: 'Group' },
      { text: 'Kullanıcılar', value: 'Users' }
    ],

    //Loading models
    fab: false,

    //Notification route flags
    isDetailFlag: false,
    flag: true,
    searchFlag: false,

    //Search modals
    select: null,
    autoLoading: false,
    search: null,
    search2: null,
    searchText: "",
    lastSearchText: "",
    lastEditTime: null,
    intervalTemp: null,
    searchResult: "",
    isCreate: false,
    deleteItemModel: {},
    userId: "",
    sendAll: false,
    isTest: false,
    comboSelect: [],
    comboItems: [],
    linkStatus: false,
    externaLinkStatus: false,
    linkText: "",
    openEmojiPickerDialog: false,
    isLoading: false,

    //Division select modals
    selectedDivision: null,
    divisionItems: [],

    //Date time modals
    dateValue: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    timeValue: "",

    //pagination field
    pagination: {},
    itemsPerPage: 15,
    perPageValues: [
      {
        name: "10",
        value: 10,
      },
      {
        name: "15",
        value: 15,
      },
      {
        name: "30",
        value: 30,
      },
      {
        name: "50",
        value: 50,
      },
      {
        name: "100",
        value: 100,
      },
    ],
  }),
  watch: {
    model(val) {
      if (val.length > 5) {
        this.$nextTick(() => this.model.pop());
      }
    },
    //Every input character is searched
    search(val) {
      // val && val !== this.select && this.searchCallNew(val);
      // if (val !== "" && val != null) {
      // } else {
      //   this.comboItems = [];
      //   this.searchResult = "";
      // }
    },
    search2(val) {
      val && val !== this.select;
    },
  },
  mounted() {
    this.setup();
    this.getTableList();
    this.getRedirectionPages();
  },
  beforeDestroy() {
    if (this.intervalTemp) {
      clearInterval(this.intervalTemp);
      this.intervalTemp = null;
    }
  },
  components: {
    StatusSelect,
    CompanySelect,
    UserCategorySelect,
    DeleteModal,
    VEmojiPicker,
    DatePicker: () => import("../components/General/DatePicker.vue"),
    TimePicker: () => import("../components/General/TimePicker.vue"),
  },
  computed: {
    targetList(){
      switch(this.selectedTarget){
        case 'AssignmentCategory':
          return this.selectedUserCategories;
        case 'Group':
          return this.selectedGroupIds; 
        case 'Users':
          return this.comboSelect;
        default:
          return [];
      }
    },
    userList(){
      return this.comboItems;
    },
    dateValueDisplay() {
      return convertToLocal(this.dateValue);
    },
    timeValueDisplay() {
      return this.timeValue;
    },
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  methods: {
    editItem(item){
      this.notificationModel = {...this.notificationModel, ...item};
      this.isCreate = true;
    },
    isScheduled(date) {
      const scheduledDate = dayjs(date, 'DD.MM.YYYY HH:mm:ss')
      
      return scheduledDate.isAfter(dayjs())
    },

    getDivisions() {
      GroupService.getDivisions()
        .then((res) => {
          this.divisionItems = res.data;
          this.divisionItems.unshift({ Id: -1, Name: "Tümü" });
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {});
    },
    changeSendAllState(item) {
      item = !item;
    },

    setup() {
      this.userId = this.$store.state.Id;
      this.selectedDivision = -1;
      this.headers = [
        {
          text: this.$t("title.notificationTitle"),
          value: "Title",
          sortable: false,
        },
        {
          text: this.$t("title.notificationType"),
          value: "TargetType",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderCreateDate"),
          value: "CreatedAt",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("labels.status"),
          value: "Status",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderActions"),
          value: "actions",
          sortable: false,
        },
        (this.pagination = {
          totalItems: 200,
          rowsPerPage: this.itemsPerPage,
          page: 1,
        }),
      ];
      this.notificationModel = {
        Title: "",
        Description: "",
      };
    },
    clearModal() {
      this.notificationModel = {
        Title: "",
        Description: "",
      };
      this.$refs.observer.reset();
      this.openEmojiPickerDialog = false;
      this.sendAll = false;
      this.comboSelect = [];
      this.selectedModuleModal = "";
      this.selectedInnerModuleModal = "";
      this.flag = false;
      this.searchFlag = false;
      this.groupArr = [[]];
      this.selectedPhotoModel = null;
      this.photoLength = 0;
      this.dateValue = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.timeValue = "";
    },
    //Fills table data
    getTableList() {
      this.$store.state.loadingStatus = true;
      this.tableData = [];

      NotificationService.getNotifications(
        this.pagination.rowsPerPage,
        this.pagination.page
      )
        .then((response) => {
          const data = response.data;
          const list = data?.Result;

          if(Array.isArray(list) && list?.length > 0){
            this.tableData = list;
            this.pagination.totalItems = data.TotalItems;
          }
        })
        .catch(handleServiceError)
        .finally(() => this.$store.state.loadingStatus = false)
    },
    //Gets redirection pages
    getRedirectionPages() {
      return;
      this.pageList = [];

      AccountService.getRedirectPages()
        .then((res) => {
          console.log("res redirect pages >> ", res.data);
          this.pageList = res.data;
        })
        .catch((err) => {
          window.showError(err);
        });
    },

    //Pop sticky button on scroll 40px
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 40;
    },
    //Sticky button publish operation
    async stickyPublishOperation() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.publish();
      }
    },
    // Emoji picker
    selectEmoji(emoji) {
      if (this.notificationModel.Description !== null) {
        this.notificationModel.Description = `${this.notificationModel.Description} ${emoji.data}`;
      } else {
        this.notificationModel.Description = emoji.data;
      }
    },
    openEmojiPicker() {
      this.openEmojiPickerDialog = true;
    },
    //Details search activated
    activateDetails() {
      this.isDetailFlag = !this.isDetailFlag;
      clearInterval(this.intervalTemp);
      this.intervalTemp = null;
    },
    //Details column is deactivated
    closeDetails(item) {
      this.isDetailFlag = true;
      this.flag = false;
      clearInterval(this.intervalTemp);
      this.intervalTemp = null;
      this.searchText = "";
      this.lastSearchText = "";
      this.allInnerModules = [];
      this.autoLoading = false;
    },

    searchCallNewTest(searchValue = "") {
      let pageSize = 99999;
      let page = 1;
      this.isLoading = true;
      UserService.getUsers(searchValue, pageSize, page)
        .then((response) => {
          this.comboItems = [...response?.data?.Result] || [];
          if (this.comboItems.length <= 0) {
            this.searchResult =
              "Aradığınız kriterde kullanıcı bulunamadı.Yeniden deneyiniz.";
          }
        })
        .catch(window.handleServiceError)
        .finally(() => {
          this.isLoading = false;
        });
    },
    //Search operation new
    searchCallNew(val) {
      this.searchText = val;
      // if (
      //   this.lastEditTime !== null &&
      //   this.lastSearchText !== this.searchText &&
      //   new Date().getTime() - this.lastEditTime > 1000 &&
      //   this.searchText !== ""
      // ) {
      //   let pageSize = 99999;
      //   let page = 1;
      //   this.isLoading = true;
      //   if (this.searchText == "" || this.searchText == null) {
      //     UserService.getUsers("", pageSize, page)
      //       .then((res) => {
      //         this.comboItems = res.data.Data;
      //       })
      //       .catch((err) => {
      //         window.showInfo(
      //           this.$t("description.tableLoadingError"),
      //           "standart",
      //           "error"
      //         );
      //       })
      //       .then(() => {
      //         // this.loadings.table = false;
      //         // this.$store.state.loadingStatus = false;
      //         this.isLoading = false;
      //       });
      //   } else {
      //     this.isLoading = true;
      //     UserService.getUsers(this.searchText, pageSize, page)
      //       .then((res) => {
      //         this.comboItems = res.data.Data;
      //         if (this.comboItems.length <= 0) {
      //           this.searchResult =
      //             "Aradığınız kriterde kullanıcı bulunamadı.Yeniden deneyiniz.";
      //         }
      //       })
      //       .catch((err) => {
      //         window.showInfo(
      //           this.$t("description.tableLoadingError"),
      //           "standart",
      //           "error"
      //         );
      //       })
      //       .then(() => {
      //         // this.loadings.table = false;
      //         // this.$store.state.loadingStatus = false;
      //         this.isLoading = false;
      //       });
      //   }
      // }
    },
    //Search operation new end
    //Search operation
    searchCall() {
      if (
        this.lastEditTime !== null &&
        this.lastSearchText !== this.searchText &&
        new Date().getTime() - this.lastEditTime > 1000 &&
        this.searchText !== ""
      ) {
        let pageSize = 99999;
        let page = 1;
        this.isLoading = true;
        if (this.searchText == "" || this.searchText == null) {
          UserService.getUsers("", pageSize, page)
            .then((res) => {
              this.comboItems = res.data.Data;
            })
            .catch((err) => {
              window.handleServiceError(err);
            })
            .then(() => {
              // this.loadings.table = false;
              // this.$store.state.loadingStatus = false;
              this.isLoading = false;
            });
        } else {
          this.isLoading = true;
          UserService.getUsers(this.searchText, pageSize, page)
            .then((res) => {
              this.comboItems = res.data.Data;
              if (this.comboItems.length <= 0) {
                this.searchResult =
                  "Aradığınız kriterde kullanıcı bulunamadı.Yeniden deneyiniz.";
              }
            })
            .catch((err) => {
              window.handleServiceError(err);
            })
            .then(() => {
              // this.loadings.table = false;
              // this.$store.state.loadingStatus = false;
              this.isLoading = false;
            });
        }

        //TODO service call
        // let param = {
        //   Search: this.searchText,
        // };
        // this.allInnerModules = [];

        // if (this.selectedModuleModal.ModuleKey == "kurumsal_haberler") {
        //   ContentService.getPosts(param)
        //     .then((res) => {
        //       console.log("Search res haber>", res.data);
        //       res.data.Data.forEach((x) => {
        //         this.allInnerModules.push({ Key: x.Id, Value: x.Title });
        //       });
        //     })
        //     .catch((err) => {
        //       window.showError(err);
        //     })
        //     .then(() => {});
        // } else if (this.selectedModuleModal.ModuleKey == "anketler") {
        //   SurveyService.getSurveys(param)
        //     .then((res) => {
        //       console.log("Search res anket> ", res.data);
        //       res.data.forEach((x) => {
        //         this.allInnerModules.push({ Key: x.Id, Value: x.Name });
        //       });
        //     })
        //     .catch((err) => {
        //       window.showError(err);
        //     })
        //     .then(() => {});
        // }
        //Clear search props
        this.lastSearchText = this.searchText;
        clearInterval(this.intervalTemp);
        this.intervalTemp = null;
      }
    },

    querySelections(v) {
      this.lastEditTime = new Date().getTime();
      this.searchText = v;
      if (!this.intervalTemp) {
        this.intervalTemp = setInterval(() => {
          this.searchCall();
        }, 2000);
      }
    },

    //File start //////////////////////////////////////////
    //Local file choose open
    browsePhoto() {
      this.$refs.uploader.click();
    },
    // Local file choose
    selectFileHandle(e) {
      if (e.target.files[0] === undefined) {
      } else {
        this.uploadFile(e.target.files[0]);
      }
    },
    onFileChange(e) {
      if (e.target.files[0] === undefined) {
      } else {
        this.selectedPhotoModel = e.target.files[0];
        this.uploadPhoto(this.selectedPhotoModel);
      }
    },
    //Return file url to send service
    computedUrl(file) {
      return URL.createObjectURL(file);
    },
    //Photo upload to service
    uploadPhoto(media) {
      let formData = new FormData();

      if (media === undefined) {
        console.log("Undefined media");
      } else {
        if (media.size > 20000000) {
          window.showInfo(
            this.$t("description.fileSizeError"),
            "standart",
            "error"
          );
        } else {
          this.selectedPhoto.push(media);
          this.tempFiles.push(media);
          this.selectedPhotoUrl.push(this.computedUrl(media));
          this.photoLength = 1;
        }
      }
    },
    //Photo delete
    deletePhoto(photo, index) {
      this.selectedPhoto.splice(index, 1);
      this.selectedPhotoUrl.splice(index, 1);
      this.selectedPhotoModel = null;

      this.photoLength--;
      this.fileIds.splice(index, 1);
    },
    //File end //////////////////////////////////////////

    //Create started
    sendForm() {
      this.publish();
    },
    //Upload photo on UI
    async uploadFiles(index) {
      if (index < this.tempFiles.length) {
        this.uploadFileCall(this.tempFiles[index], index);
      } else {
        this.publishCall();
      }
    },
    //Upload photo call
    async uploadFileCall(media, index) {
      if (media === undefined) {
        console.log("Undefined media");
      }
      let formData = new FormData();
      if (
        media.type == "image/jpeg" ||
        media.type == "image/png" ||
        media.type == "video/mp4"
      ) {
        formData.append("Files", media);
        formData.append("Type", "media");
      } else {
        formData.append("Files", media);
        formData.append("Type", "document");
      }

      await Promise.resolve(
        FileService.uploadFile(formData)
          .then((res) => {
            this.fileIds.push(res.data[0].Id);
          })
          .catch((err) => {
            window.handleServiceError(err);
          })
          .then(() => {
            this.uploadFiles(index + 1);
          })
      );
    },
    
    /**
     * 
     * @param {{ Value: string, Key: string, IsDetail: boolean, IsRedirectPage: boolean }} modal
     */
    fillInnerSelectPage(modal) {
      this.flag = true;
      this.isDetailFlag = false;
      this.linkText = "";
      this.allInnerModules = [];

      if (
        modal.Key != null &&
        modal.Key != "anketler" &&
        modal.Key != "bugun_doganlar"
      ) {
        this.autoLoading = true;
        ContentService.getPosts({ key: modal.Key })
          .then((res) => {
            res.data.Data.forEach((x) => {
              this.allInnerModules.push({
                Key: x.Id,
                Value: x.Title
                  ? x.Title
                  : x.Content
                  ? x.Content.split(" ").slice(0, 5)
                  : x.User.FullName + " Gönderisi",
              });
            });
          })
          .catch(window.handleServiceError)
          .then(() => this.autoLoading = false);
      }  else {
        this.autoLoading = false;
      }
    },

    //Create notification
    async publish() {
      this.publishCall();
    },

    //Create notification and call service
    publishCall() {
      //this.$store.state.loadingStatus = true;
      var sendedAt = this.dateValue;
      if(this.timeValue){
        sendedAt += ("T" + this.timeValue);
      }

      const status = this.notificationModel.Status || 0;

      const body = {
        Title: this.notificationModel.Title,
        Description: this.notificationModel.Description,
        Target: this.targetList,
        TargetType: this.selectedTarget,
        SendedAt: sendedAt,
        ContentId: 0,
        ContentType: "",
        Data: null,
        Status: status,
        ...this.notificationSettings
      };
        
      if(this.selectedModuleModal?.IsDetail){
        body.Data = {
          "type": 'post',
          "id": this.selectedInnerModuleModal?.toString()
        };
      }
      else{
        body.Data = {
          type: `:link:${this.selectedModuleModal?.Key}`,
          id: null,
          params: this.selectedModuleModal?.Params
        }
      }
      this.sendNotificationService(body);
    },

    sendNotificationService(body) {
      if (body.Target === undefined) {
        window.showInfo(
          this.$t("description.notificationTargetError"),
          "standart",
          "error"
        );
        this.$store.state.loadingStatus = false;
        return;
      } else {
        NotificationService.createNotification(body)
          .then((res) => {
             window.showSuccess("Bildirim başarılı bir şekilde eklendi.")
            this.isCreate = false;
            this.getTableList();
            this.clearModal();
          })
          .catch(window.handleServiceError)
          .finally(() =>this.$store.state.loadingStatus = false);
      }
    },

    //Opens modal for deletion operation
    openDeleteModal(item) {
      this.deleteItemModel = item;
      this.$refs.deleteModalRef.modalStatus = true;
    },
    //Delete operation
    deleteItem() {
      // this.loadings.table = true;
      this.$store.state.loadingStatus = true;
      NotificationService.deleteNotification(this.deleteItemModel.Id)
        .then(() => {
          this.$store.state.loadingStatus = false;
          this.$refs.deleteModalRef.modalStatus = false;
          this.getTableList();
          this.getMenuData();
        })
        .catch((err) => {
          window.handleServiceError(err);
        })
        .then(() => {
          // this.loadings.table = false;
          // this.$store.state.loadingStatus = false;
        });
    },

    changeItemsPerPage() {
      this.pagination.rowsPerPage = this.itemsPerPage;
      this.pagination.page = 1;
      this.options.itemsPerPage = this.itemsPerPage;
      this.getTableList();
    },
    paginationChangeHandler(pageNumber) {
      this.pagination.page = pageNumber;
      this.getTableList();
    },

    ...mapActions(["getMenuData"]),
  },
};
</script>

<style>
.error--text {
  font-size: 14px;
}

.ck-editor__editable {
  min-height: 278px;
}

.ck-content {
  border-bottom-left-radius: 11px !important;
  border-bottom-right-radius: 11px !important;
}

.ck-toolbar {
  border-top-left-radius: 11px !important;
  border-top-right-radius: 11px !important;
  background: #fafafa !important;
}

.ck.ck-toolbar {
  background: transparent;
  background-image: linear-gradient(#ffffff, #ededed);
}
</style>
